module.exports = __webpack_public_path__ + "img/newbg_t.4cd661a9.png";